export default __webpack_public_path__ + "static/images/book-29a5c574c6db64606066c30e97bf37a4.png";